import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { titleCase } from "../../utils/title-case";

const TdMarker = ({
  drugPrice,
  active,
  selected,
  onMouseEnter,
  onMouseLeave,
  onClick
}) => {
  const { PharmacyName, Street1, Distance, City, State, ZipCode } = drugPrice;
  return (
    <div>
      <div
        role='button'
        tabIndex={0}
        onKeyDown={onClick}
        className={`g-map-marker-web-sdk ${active || selected ? "active" : ""}`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      >
        {" "}
      </div>
      {selected && (
        <div className='g-map-tooltip-web-sdk'>
          <div className='g-map-tooltip-header-web-sdk'>
            {titleCase(PharmacyName)}
          </div>
          <div className='websdk-flex websdk-justify-between g-map-tooltip-section-web-sdk'>
            <div>{titleCase(Street1)}</div>
            <div>{Distance.toFixed(2)} mi</div>
          </div>
          <div className='g-map-tooltip-section-web-sdk'>
            {titleCase(City)}, {State} {ZipCode}
          </div>
        </div>
      )}
    </div>
  );
};

const DrugPriceMap = ({
  drugPrices,
  mapCenter,
  activeItem,
  selectedItem,
  onItemMouseEnter,
  onItemMouseLeave,
  onItemClick,
  components
}) => {
  const { GMap } = components;

  const renderLocations = useCallback(
    ({ map, maps: { LatLng, LatLngBounds } }) => {
      const bounds = new LatLngBounds();
      drugPrices.forEach(({ Latitude, Longitude }) => {
        const lat = parseFloat(Latitude);
        const lng = parseFloat(Longitude);
        bounds.extend(new LatLng(lat, lng));
      });
      map.fitBounds(bounds);
    },
    [drugPrices]
  );

  return (
    <div className='price-prescriptions-map-web-sdk'>
      <GMap renderLocations={renderLocations} center={mapCenter}>
        {drugPrices.map(drugPrice => {
          const { PharmacyId, Latitude, Longitude } = drugPrice;
          return (
            <TdMarker
              key={PharmacyId}
              drugPrice={drugPrice}
              active={PharmacyId === activeItem}
              selected={PharmacyId === selectedItem}
              onMouseEnter={() => onItemMouseEnter(drugPrice)}
              onMouseLeave={() => onItemMouseLeave(drugPrice)}
              onClick={() => onItemClick(drugPrice)}
              lat={parseFloat(Latitude)}
              lng={parseFloat(Longitude)}
            />
          );
        })}
      </GMap>
    </div>
  );
};

export default DrugPriceMap;

DrugPriceMap.propTypes = {
  drugPrices: PropTypes.array,
  mapCenter: PropTypes.arrayOf(PropTypes.number, PropTypes.number),
  activeItem: PropTypes.string,
  selectedItem: PropTypes.string,
  onItemMouseEnter: PropTypes.func,
  onItemMouseLeave: PropTypes.func,
  onItemClick: PropTypes.func,
  components: PropTypes.object
};

TdMarker.propTypes = {
  drugPrice: PropTypes.any,
  active: PropTypes.bool,
  selected: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func
};
